import { useDispatch } from 'react-redux';
import { createCashbox } from '@redux/features/cashboxesSlice';
import { AccountForm } from './AccountForm';

export const CreateAccountForm = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();

  const onSubmit = async (values, { resetForm }) => {
    const submitData = {
      name: values.name,
      ...(values.balance && { balance: parseInt(values.balance) }),
      method: values.method,
    };

    const resultAction = await dispatch(createCashbox(submitData));

    if (createCashbox.fulfilled.match(resultAction)) {
      setIsOpen(false);
      resetForm();
    }
  };

  return (
    <AccountForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title='Створити новий рахунок'
      submitText='Створити рахунок'
      balanceLabel='Початковий баланс'
      balancePlaceholder='Введіть початковий баланс'
      initialValues={{
        name: '',
        balance: '',
        method: '',
      }}
      onSubmit={onSubmit}
    />
  );
};
